import { render, staticRenderFns } from "./OverwriteCard.vue?vue&type=template&id=309a3f97&"
import script from "./OverwriteCard.vue?vue&type=script&lang=ts&"
export * from "./OverwriteCard.vue?vue&type=script&lang=ts&"
import style0 from "./OverwriteCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports